import { Checkbox, Col, Form, Input, message, Row } from 'antd';
import { Button } from 'components';
import { useLogin } from 'features/auth/use-cases';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { ROUTES } from 'routes/constants';

import { LoginFormField, LoginFormValues } from './types';

export const LoginForm = () => {
  const { mutate, isLoading } = useLogin();
  const navigate = useNavigate();
  const [validateTrigger, setValidateTrigger] = useState(['onSubmit']);
  const [form] = Form.useForm<LoginFormValues>();
  const { t } = useTranslation();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const returnUrl: any = queryParams?.get('returnUrl');
  // let id: any, clientid: any, uniqueid: any;
  // if (returnUrl) {
  //   returnUrl?.split('/');
  // }
  // const [_,id, clientid, uniqueid] = returnUrl?.split('/')
  // ? returnUrl?.split('/')
  // : '';
  const [, id, clientid, uniqueid] = (returnUrl && returnUrl.split('/')) || [
    '',
    '',
    '',
  ];
  // if (returnUrl) {
  //   // Split the returnUrl by '/' and destructure the result
  //   const parts = returnUrl.split('/');

  //   // Ensure there are enough parts to avoid undefined values
  //   if (parts.length >= 4) {
  //     id = parts[1]; // Second part
  //     clientid = parts[2]; // Third part
  //     uniqueid = parts[3]; // Fourth part
  //   } else {
  //     console.error('Return URL does not have enough segments:', returnUrl);
  //   }
  // } else {
  //   console.error('Return URL is not defined');
  // }
  const handleLogin = ({
    Email,
    Password,
  }: // RememberLogin,
  LoginFormValues) => {
    // Perform login mutation
    mutate(
      { Email, Password, persistSession: true, UserType: 2 },
      {
        onSuccess: (data: any) => {
          if (data?.rs == 1) {
            const userId = data?.res?.UserId;
            localStorage.setItem('userId', userId);
            localStorage.setItem('userEmail', Email);
            if (returnUrl && id && clientid && uniqueid) {
              navigate(`/otp?rtt=${id}/${clientid}/${uniqueid}`, {
                replace: true,
              });
            } else if (returnUrl && id && clientid) {
              navigate(`/otp?rtt=${id}/${clientid}`, { replace: true });
            } else {
              navigate(`${ROUTES.OTP}`, { replace: true });
            }
          } else {
            message.error(data?.rm);
          }
        },
      },
    );
  };

  return (
    <Form
      form={form}
      layout='vertical'
      onFinish={handleLogin}
      onFinishFailed={() => {
        setValidateTrigger(['onChange']);
      }}
      wrapperCol={{ span: 24 }}
      validateTrigger={validateTrigger}
    >
      <Form.Item
        label={t('login.formFields.email.label')}
        name={LoginFormField.Email}
        rules={[
          { required: true, message: 'Email is required' }, // Required validation
          { type: 'email', message: 'Please enter a valid email address' }, // Email format validation
        ]}
      >
        <Input
          type='text'
          autoComplete='username'
          placeholder={'Enter Email'}
          size='large'
        />
      </Form.Item>

      <Form.Item
        label={t('login.formFields.password.label')}
        name={LoginFormField.Password}
        rules={[
          {
            required: true,
            message: 'Password is required',
          },
        ]}
      >
        <Input.Password
          autoComplete='current-password'
          // prefix={<LockOutlined className='input-prefix-icon' />}
          placeholder={t('login.formFields.password.placeholder')}
          size='large'
        />
      </Form.Item>
      <Row justify='space-between' align='middle' className='mb-6'>
        <Col>
          <Form.Item
            name={LoginFormField.Remember}
            valuePropName='checked'
            initialValue={true}
            className='mb-0'
          >
            <Checkbox>{t('login.formFields.rememberMe.label')}</Checkbox>
          </Form.Item>
        </Col>
        <Col>
          <Link to={ROUTES.CHANGE_PASSWORD}>
            {t('login.formFields.passwordForget.label')}
          </Link>
        </Col>
      </Row>
      <Button
        type='primary'
        size='large'
        htmlType='submit'
        block
        loading={isLoading}
        className='shadow-none'
      >
        {t('login.submit')}
      </Button>
      <div className='sign_up'>
        <p>If you don &apos; t have account?</p>
        <Link to={ROUTES.SIGNUP}>Sign up</Link>
      </div>
    </Form>
  );
};
